import { computed } from 'vue';
import { useHamburgerMenu } from './useHamburgerMenu';
import BcomFobTitle from '#shared/constants/bcom/MobileFobTitle';

function addHardcodedLinkMcom(node, id) {
  const result = node?.children || [];

  if (node?.url) {
    const { isCatSplash } = node;
    let beginning;

    if (isCatSplash) {
      beginning = 'Featured For';
    } else {
      beginning = node.text.startsWith('All ') ? 'See' : 'See All';
    }

    const parent = {
      id,
      url: node.url,
      text: `${beginning} ${node.text}`,
      isParentCategory: true,
    };

    return [parent, ...result];
  }

  return result;
}

function addHardcodedLinkBcom(node, id) {
  const result = node?.children || [];

  if (node?.url) {
    const parent = {
      id,
      url: node.url,
      text: BcomFobTitle[id] || 'See All',
      isParentCategory: true,
    };
    return [parent, ...result];
  }

  return result;
}

export function useHamburgerSubCategories() {
  const { menu } = useHamburgerMenu();
  const { isMcom } = useEnvProps();

  function getCategory(id) {
    const flyout = menu.value[id];

    return {
      ...flyout,
      children: isMcom ? addHardcodedLinkMcom(flyout, id) : addHardcodedLinkBcom(flyout, id),
    };
  }

  const subCategories = computed(() => {
    const allCategoryIds = Object.keys(menu.value).reduce((acc, id) => {
      if (menu.value[id].children?.length) {
        acc.push(id);
      }

      return acc;
    }, []);

    return allCategoryIds.map(getCategory);
  });

  return { subCategories, getCategory };
}
